import { Action } from '@ngrx/store';
import { IPlantPlanet } from 'src/commons';

export enum PlantPlanetActionTypes {
  LoadPlantPlanetState = '[PlantPlanet] Load PlantPlanet State',
  LoadPlantPlanetStateSuccess = '[PlantPlanet] Load PlantPlanet State Success',
  LoadPlantPlanetStateFail = '[PlantPlanet] Load PlantPlanet State Fail',
  PlantPlanetScreenErrorReset = '[PlantPlanet] PlantPlanet Screen Error Reset'

}

export class LoadPlantPlanetState implements Action {
  readonly type = PlantPlanetActionTypes.LoadPlantPlanetState;
  constructor(public payload: number ) {}
}

export class LoadPlantPlanetStateSuccess implements Action {
  readonly type = PlantPlanetActionTypes.LoadPlantPlanetStateSuccess;
  constructor(public payload: IPlantPlanet ) {}
}

export class LoadPlantPlanetStateFail implements Action {
  readonly type = PlantPlanetActionTypes.LoadPlantPlanetStateFail;
  constructor(public payload: any) {}
}

export class PlantPlanetScreenErrorReset implements Action {
  readonly type = PlantPlanetActionTypes.PlantPlanetScreenErrorReset;
}

export type PlantPlanetActions = 
  LoadPlantPlanetState
  | LoadPlantPlanetStateSuccess
  | LoadPlantPlanetStateFail
  | PlantPlanetScreenErrorReset;